export var createBrandsApi = function (baseUrl, http) {
    var brandApiUrl = baseUrl + "/brand";
    return {
        getAllBrands: function (enabled) {
            return http.get("" + brandApiUrl + (enabled ? '?enabled=true' : ''));
        },
        getBrand: function (dto) {
            return http.get(brandApiUrl + "/" + dto.id);
        },
        addBrand: function (dto) {
            return http.post(brandApiUrl, dto);
        },
        updateBrand: function (dto) {
            return http.post(brandApiUrl + "/" + dto.id + "/update", { name: dto.name, logoUrl: dto.logoUrl });
        },
        enableBrand: function (dto) {
            return http.post(brandApiUrl + "/" + dto.id + "/enable", {});
        },
        disableBrand: function (dto) {
            return http.post(brandApiUrl + "/" + dto.id + "/disable", {});
        },
        isSubdomainAvailable: function (name) {
            return http.post(brandApiUrl + "/nameAvailable", { name: name });
        }
    };
};
//# sourceMappingURL=index.js.map